
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"glassesPrescriptionsPatient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"glassesPrescriptionsPatient"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"patientId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"patientId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"observations"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasReadingGlasses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasDistanceGlasses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextAttendanceDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distanceGlasses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sphericalLeftEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sphericalRightEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cylindricalLeftEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cylindricalRightEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"axisLeftEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"axisRightEye"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"readingGlasses"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sphericalLeftEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sphericalRightEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cylindricalLeftEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cylindricalRightEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"axisLeftEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"axisRightEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additionClose"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"additionIntermediary"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pupillaryDistance"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"leftEye"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rightEye"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lastEsign"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileExtension"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileSize"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":787}};
    doc.loc.source = {"body":"query glassesPrescriptionsPatient($patientId: ID!) {\n  glassesPrescriptionsPatient(patientId: $patientId) {\n    id\n    observations\n    hasReadingGlasses\n    hasDistanceGlasses\n    nextAttendanceDate\n    distanceGlasses {\n      id\n      sphericalLeftEye\n      sphericalRightEye\n      cylindricalLeftEye\n      cylindricalRightEye\n      axisLeftEye\n      axisRightEye\n    }\n    readingGlasses {\n      id\n      sphericalLeftEye\n      sphericalRightEye\n      cylindricalLeftEye\n      cylindricalRightEye\n      axisLeftEye\n      axisRightEye\n      additionClose\n      additionIntermediary\n    }\n    pupillaryDistance {\n      id\n      leftEye\n      rightEye\n    }\n    lastEsign {\n      id\n      status\n      signedAt\n      fileUrl\n      fileName\n      fileExtension\n      fileSize\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["glassesPrescriptionsPatient"] = oneQuery(doc, "glassesPrescriptionsPatient");
        
